import React from "react";

import OptionsImage from "./options-image";

const UpsellBlock = (props) => {

    if (!props.content || !Object.values(props.content).some(value => Boolean(value))) return null;

    return (
        <div className={`upsell-block upsell-block__${props.type}`}>
            <div className="upsell-block__content">
                {props.content.title &&
                    <h3 className="upsell-block__header">{props.content.title}</h3>
                }
                {props.content.introduction &&
                    <div className="upsell-block__introduction" dangerouslySetInnerHTML={{__html: props.content.introduction}}></div>
                }
                {props.content.button?.url &&
                    <div className='upsell-block__button'>
                        <a href={props.content.button.url} className="btn">
                            {props.content.button.title ? props.content.button.title : "Find out more"}
                        </a>
                    </div>
                }
            </div>
            {props.content.image &&
                <div className="upsell-block__image">
                    <OptionsImage image={props.content.image} />
                </div>
            }
        </div>
    );
};

export default UpsellBlock;